export var TabsPosition;
(function (TabsPosition) {
    TabsPosition["LEFT"] = "left";
    TabsPosition["RIGHT"] = "right";
})(TabsPosition || (TabsPosition = {}));
export const tabsPositionClassMap = {
    [TabsPosition.LEFT]: 'justify-start',
    [TabsPosition.RIGHT]: 'justify-end',
};
